import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import {
  type AccountSettings,
  accountSettings,
} from "../schemas/accountSettings";

export const updateAccountSettingsProps = z
  .object({
    token: z.string(),
    acceptsSms: z.boolean().optional(),
    acceptsEmail: z.boolean().optional(),
  })
  .extend(requestConfig.shape);

export type UpdateAccountSettingsProps = z.infer<
  typeof updateAccountSettingsProps
>;

export const updateAccountSettings = async (
  args: UpdateAccountSettingsProps,
): Promise<AccountSettings> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    token,
    acceptsSms,
    acceptsEmail,
    proxyAuthSecret,
  } = parseServiceInput(updateAccountSettingsProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(`${endpoint}/v1/account/settings`, {
    method: "PUT",
    headers,
    body: JSON.stringify({
      acceptsSms: Boolean(acceptsSms),
      acceptsEmail: Boolean(acceptsEmail),
    }),
  });

  return parseServiceOutput(response, accountSettings, {
    code: "MALFORMED_ACCOUNT_SETTINGS",
    message: "Account settings is malformed",
  });
};
